<ng-container *ngIf="redesign; else noRedesign">
  <div [attr.data-qa]="'top-bucket-redesign'" class="container mt-4" *ngIf="_aggregationService.contractcnt > 1 && showTopBucket">
    <div class="row">
      <div class="aggr-content redesign-view col-xs-12">
        <div class="summary-header">
          <div *ngIf="!_genericService.spinner">
            <div *ngIf="compData && compData.aggVal">
              <!-- redesigned summary bucket -->
              <div id="summaryExpansion" class="panel-group">
                <ng-container *ngFor="let obj of compData.aggVal; let i = index">
                  <div class="panel panel-default px-0 expansion-panel" *ngIf="obj.value !== '0'">
                    <div class="panel-heading" [attr.data-qa]="'top-bucket-key-title-'+i">
                      <div class="panel-title aggr-summary-header h4">
                        <div class="row">
                          <div class="col-xs-6 col-sm-8">
                            <div class="title-wrapper">
                              <ng-container *ngIf="obj.key == 'Income'">
                              <span class="content-title" *ngIf="_aggregationService.noGuaranteeIncome"><h2>Annual Retirement Income</h2>
                              </span>
                              <span class="content-title" *ngIf="!_aggregationService.noGuaranteeIncome"><h2>Guaranteed Annual Income</h2>
                              </span>
                            </ng-container>
                            <span
                              class="content-title"
                              *ngIf="obj.key != 'Income'"
                              ><h2>{{ obj.key }}</h2>
                            </span>
                            <pru-tooltip
                              *ngIf="obj.value !== '0'"
                              [definitionID]="
                                obj.key === 'Assets'
                                  ? 'YourAssets'
                                  : obj.key === 'Income' &&
                                    _aggregationService.noGuaranteeIncome
                                  ? 'YourNGIncome'
                                  : obj.key === 'Income' &&
                                    !_aggregationService.noGuaranteeIncome
                                  ? 'YourIncome'
                                  : 'YourBenefits'
                              "
                              [definitionLocation]="
                                'UCD_Content/SA-LegalStatement'
                              "
                              [clickTitle]="
                                obj.key === 'Assets'
                                  ? 'YourAssets'
                                  : obj.key === 'Income'
                                  ? 'YourIncome'
                                  : 'YourBenefits'
                              "
                              [screenReaderText]="
                                obj.key === 'Assets'
                                  ? 'Your Assets'
                                  : obj.key === 'Income'
                                  ? 'Your Income'
                                  : 'Your Benefits'
                              "
                              [analyticData]="
                                obj.key === 'Assets'
                                  ? 'Assets'
                                  : obj.key === 'Income'
                                  ? 'Income'
                                  : 'Benefits'
                              "
                            >
                            </pru-tooltip>
                            </div>
                            
                          </div>
                          <div class="col-xs-6 col-sm-4">
                            <span class="pull-right aggr-summary-val mr-sm-4" *ngIf="obj.value !== '0'">
                              {{obj.value | currency: 'USD':'symbol-narrow':'1.2-2'}}
                            </span>
                          </div>
                        </div>
                        <button
                         [attr.data-qa]="'expand-collapse-btn'"
                          class="accordion-icon-control collapsed"
                          data-toggle="collapse"
                          data-parent="#summaryExpansion"
                          [attr.aria-expanded]="false"
                          [attr.href]="'#summaryBucket_' + i"
                          [attr.data-analytics]="obj.key"
                          [attr.aria-controls]="'summaryBucket_' + i"
                        >
                          <span class="sr-only">expend/collapse {{obj.key}} summary section</span>
                        </button>
                      </div>
                    </div>
                    <div
                      *ngIf="obj.value !== '0'"
                      class="panel-collapse collapse"
                      [ngClass]="{ in: i === _genericService.aggSummary }"
                      [attr.id]="'summaryBucket_' + i"
                    >
                      <div
                        class="panel-body"
                        *ngFor="let contract of _genericService.filteredCont[0]"
                      >
                        <div [attr.data-qa]="'top-bucket-panel-body'"
                          *ngIf="
                            contract.primaryContractValue &&
                            contract.primaryContractValue.contributesTo &&
                            obj.key
                              .toLowerCase()
                              .indexOf(
                                contract.primaryContractValue.contributesTo.toLowerCase()
                              ) > -1
                          "
                        >
                          <div class="col-xs-8 pl-0 btn-sm-block" [attr.data-qa]="'top-bucket-panel-accountType'">
                            <div class="pt-3">
                              <span
                                *ngIf="
                                  contract.accountType &&
                                    contract.accountType.toLowerCase() ===
                                      'external account';
                                  else getLineOfBusiness
                                "
                                class="product-subtitle text-capitalize"
                                >{{ contract.accountType }}</span
                              >
                              <ng-template #getLineOfBusiness>
                                <span
                                  *ngIf="!contract.accountType"
                                  class="product-subtitle text-capitalize"
                                  >{{
                                    contract.lineOfBusinessDisplay ||
                                      contract.lineOfBusiness
                                  }}</span
                                >
                              </ng-template>
                              <span
                                *ngIf="
                                  contract.accountType &&
                                    contract.accountType.toLowerCase() ===
                                      'external account';
                                  else otherLinks
                                "
                                class="summary-link"
                              >
                                <span
                                  *ngIf="
                                    contract.contractID &&
                                    contract.contractID.indexOf(
                                      'not available'
                                    ) <= 0
                                  "
                                >
                                  <span class="sr-only">Account Number: </span>
                                  #{{
                                    contract.contractID || contract.contractId
                                  }}
                                </span>
                              </span>
                              <ng-template #otherLinks>
                                <span
                                  *ngIf="
                                    !contract.accountType &&
                                    contract.lineOfBusiness.toLowerCase() !=
                                      'retirement'
                                  "
                                >
                                  <a
                                    class="summary-link"
                                    [href]="
                                      contract.contractDetailLink
                                        | contractDetails
                                          : contract.lineOfBusiness
                                          : contract.contractID ||
                                              contract.contractId
                                    "
                                  >
                                    <span class="sr-only">Account Number:</span>
                                    #{{
                                      contract.contractID
                                        | mask
                                          : contract.maskContractID ||
                                              (contract.productTypeHeader &&
                                                contract.productTypeHeader.indexOf(
                                                  'Masked'
                                                ) > -1) ||
                                              contract.contractId
                                        | mask
                                          : contract.maskContractId ||
                                              (contract.productTypeHeader &&
                                                contract.productTypeHeader.indexOf(
                                                  'Masked'
                                                ) > -1)
                                    }}
                                  </a>
                                </span>
                              </ng-template>
                            </div>
                            <div class="mb-3">
                              <span
                                class="product-subtitle summary-link"
                                *ngIf="
                                  contract.accountType &&
                                    contract.accountType.toLowerCase() ===
                                      'external account';
                                  else otherTitles
                                "
                              >
                                <span
                                  *ngIf="contract.productTitle"
                                  class="text-capitalize"
                                  >{{ contract.productTitle }}</span
                                >
                              </span>
                              <ng-template #otherTitles>
                                <ng-container
                                  *ngIf="contract.enable2FA; else notHrt"
                                >
                                  <a
                                    class="product-subtitle summary-link two-factor-modal"
                                    href="javascript:void(0);"
                                    two-factor-auth-modal
                                    [contract]="contract"
                                    [modalId]="
                                      '2fa_' + contract.contractID + '_' + i
                                    "
                                  >
                                    <span
                                      class="transclude-content two-factor-modal text-capitalize product-type"
                                      >{{ contract.productType }}</span
                                    >
                                    <span
                                      class="transclude-content two-factor-modal"
                                      >{{
                                        contract.primaryContractValue.title
                                      }}</span
                                    >
                                  </a>
                                </ng-container>
                                <ng-template #notHrt>
                                  <a
                                    class="product-subtitle summary-link"
                                    *ngIf="!contract.accountType"
                                    [href]="
                                      contract.contractDetailLink
                                        | contractDetails
                                          : contract.lineOfBusiness
                                          : contract.contractID ||
                                              contract.contractId
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        contract.lineOfBusiness.toLowerCase() !==
                                        'annuity'
                                      "
                                      class="text-capitalize product-type"
                                      >{{ contract.productType }}</span
                                    >
                                    <span
                                      *ngIf="
                                        contract.lineOfBusiness.toLowerCase() ==
                                        'mutual funds'
                                      "
                                      >Mutual Funds</span
                                    >
                                    <span
                                      *ngIf="
                                        contract.lineOfBusiness.toLowerCase() !==
                                        'mutual funds'
                                      "
                                      >{{
                                        contract.primaryContractValue.title
                                      }}</span
                                    >
                                  </a>
                                </ng-template>
                                <!-- <a class="product-subtitle h4 summary-link" *ngIf="!contract.accountType" [href]="contract.contractDetailLink | contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)">
                                          <span *ngIf="contract.lineOfBusiness.toLowerCase() !== 'annuity'" class="text-capitalize product-type">{{contract.productType}}</span>
                                          <span *ngIf="contract.lineOfBusiness.toLowerCase() == 'mutual funds'">Mutual Funds</span>
                                          <span *ngIf="contract.lineOfBusiness.toLowerCase() !== 'mutual funds'">{{contract.primaryContractValue.title}}</span>
                                          </a> -->
                              </ng-template>
                            </div>
                          </div>
                          <div class="col-xs-4 summary-value" [attr.data-qa]="'top-bucket-panel-accountValue'">
                            {{
                              contract.primaryContractValue.value
                                | currency: 'USD':'symbol-narrow':'1.2-2'
                            }}{{ obj.key == 'Income' ? '/yr' : '' }}
                          </div>
                        </div>
                        <div
                          *ngIf="
                            contract.secondaryContractValues &&
                            contract.secondaryContractValues.length > 0
                          "
                        >
                          <div
                            *ngFor="
                              let sec of contract.secondaryContractValues[0]
                                .group
                            "
                          >
                            <div
                              *ngIf="
                                sec.contributesTo &&
                                obj.key
                                  .toLowerCase()
                                  .indexOf(sec.contributesTo.toLowerCase()) > -1
                              "
                            >
                              <div class="col-xs-8 pl-0 btn-sm-block" [attr.data-qa]="'top-bucket-sec-accountType'">
                                <div class="pt-3">
                                  <span class="product-subtitle">{{
                                    contract.lineOfBusinessDisplay ||
                                      contract.lineOfBusiness
                                  }}</span>
                                  <span>
                                    <a
                                      class="summary-link"
                                      [href]="
                                        contract.contractDetailLink
                                          | contractDetails
                                            : contract.lineOfBusiness
                                            : contract.contractID ||
                                                contract.contractId
                                      "
                                    >
                                      <span class="sr-only"
                                        >Account Number:
                                      </span>
                                      #{{
                                        contract.contractID
                                          | mask
                                            : contract.maskContractID ||
                                                (contract.productTypeHeader &&
                                                  contract.productTypeHeader.indexOf(
                                                    'Masked'
                                                  ) > -1) ||
                                                contract.contractId
                                          | mask
                                            : contract.maskContractId ||
                                                (contract.productTypeHeader &&
                                                  contract.productTypeHeader.indexOf(
                                                    'Masked'
                                                  ) > -1)
                                      }}
                                    </a>
                                  </span>
                                </div>
                                <div class="mb-3">
                                  <a
                                    class="product-subtitle summary-link"
                                    [href]="
                                      contract.contractDetailLink
                                        | contractDetails
                                          : contract.lineOfBusiness
                                          : contract.contractID ||
                                              contract.contractId
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        contract.lineOfBusiness.toLowerCase() !==
                                        'annuity'
                                      "
                                      class="text-capitalize product-type"
                                      >{{ contract.productType }}</span
                                    >
                                    <span
                                      *ngIf="
                                        contract.lineOfBusiness.toLowerCase() ==
                                        'mutual funds'
                                      "
                                      >Mutual Funds</span
                                    >
                                    <span
                                      *ngIf="
                                        contract.lineOfBusiness.toLowerCase() !==
                                        'mutual funds'
                                      "
                                      >{{ sec.title }}</span
                                    >
                                  </a>
                                </div>
                              </div>
                              <div class="col-xs-4 summary-value" [attr.data-qa]="'top-bucket-sec-accountValue'">
                                {{
                                  sec.value
                                    | currency: 'USD':'symbol-narrow':'1.2-2'
                                }}{{ obj.key == 'Income' ? '/yr' : '' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              <!-- /redesigned summary bucket-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #noRedesign>
  <div class="aggr-content container mt-4" [attr.data-qa]="'top-bucket-noRedesign'">
    <div class="summary-header col-xs-12 rt-sm rb-sm">
      <div *ngIf="_genericService.spinner">
        <div class="row">
          <div class="wrap" *ngFor="let n of [0, 1, 2]">
            <div class="col-md-4">
              <div class="row">
                <div class="col-xs-12 text-center">
                  <div class="wrapper pt-4 pb-4">
                    <span class="fa fa-spinner fa-pulse fa-2x fa-fw"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!_genericService.spinner">
        <div class="" *ngIf="compData && compData.aggVal; else errorCompData">
          <div id="summaryExpansion"  class="row panel-group ml-3 mr-3" *ngIf="_genericService.filteredCont[0] && showFlag">
            <div class="row visible-xs-block">
              <div class="col-xs-12 aggr-summary-bottom">
                <a href="javascript:void(0)" [attr.data-qa]="'top-bucket-backToSummary-link'" (click)="showFlag = false; this.activateSD('.activeSD')">
                  <span class="fa fa-arrow-circle-left fa-fw"  aria-hidden="true"></span>Back to Summary</a>
              </div>
            </div>
            <div
              class="col-md-9 panel panel-default px-0 expansion-panel"
              *ngFor="let obj of compData.aggVal; let i = index"
            >
              <div class="panel-heading">
                <div class="panel-title">
                  <a
                    [attr.data-qa]="'top-bucket-expansion-panel-'+i"
                    class="accordion-icon-control aggr-summary-header h4"
                    [ngClass]="{ collapsed: i !== _genericService.aggSummary, activeDetail: activeSD==i }"
                    data-toggle="collapse"
                    data-parent="#summaryExpansion"
                    [attr.aria-expanded]="true"
                    [attr.href]="'#summaryBucket_' + i"
                    [attr.data-analytics]="obj.key" 
                    role="button"
                  >
                    <div [attr.data-qa]="'top-bucket-key-title-'+i">
                      
                      <span
                        class="fa fa-angle-down accordion-icon pull-left"
                        aria-hidden="true"
                      ></span>
                      <ng-container *ngIf="obj.value == '0'; else showfixedtitle">
                      <span class="content-title">
                        &nbsp; {{topBucketData[i].category}}
                      </span>
                      </ng-container>
                      <ng-template #showfixedtitle>
                        <span *ngIf="obj.key == 'Income'">
                        <span
                          class="content-title"
                          *ngIf="_aggregationService.noGuaranteeIncome"
                        >
                          &nbsp; Annual Retirement Income
                        </span>
                        <span
                          class="content-title"
                          *ngIf="!_aggregationService.noGuaranteeIncome"
                        >
                          &nbsp; Guaranteed Annual Income
                        </span>
                      </span>
                      <span class="content-title" *ngIf="obj.key != 'Income'">
                        &nbsp; {{ obj.key }}
                      </span>
                      </ng-template>
                     
                      <span
                        class="pull-sm-right pull-md-right pull-lg-right btn-sm-block aggr-summary-val"
                        *ngIf="obj.value !== '0'"
                        >{{
                          obj.value | currency: 'USD':'symbol-narrow':'1.2-2'
                        }}</span
                      >
                    </div>
                  </a>
                </div>
              </div>
              <div
                *ngIf="obj.value !== '0'"
                class="panel-collapse collapse"
                [ngClass]="{ in: i === _genericService.aggSummary }"
                [attr.data-qa]="'top-bucket-expansion-summaryBucket_' + i"
                [attr.id]="'summaryBucket_' + i"
              >
                <div
                  class="panel-body"
                  *ngFor="let contract of _genericService.filteredCont[0]"
                >
                  <div
                    *ngIf="
                      contract.primaryContractValue &&
                      contract.primaryContractValue.contributesTo &&
                      obj.key
                        .toLowerCase()
                        .indexOf(
                          contract.primaryContractValue.contributesTo.toLowerCase()
                        ) > -1
                    "
                  >
                    <div class="col-xs-8 pl-0 btn-sm-block">
                      <div class="pt-2" [attr.data-qa]="'top-bucket-expansion-product-subtitle'">
                        <span
                          *ngIf="
                            contract.accountType &&
                              contract.accountType.toLowerCase() ===
                                'external account';
                            else getLineOfBusiness
                          "
                          class="product-subtitle h4 text-capitalize"
                          >{{ contract.accountType }}</span
                        >
                        <ng-template #getLineOfBusiness>
                          <span
                            *ngIf="!contract.accountType"
                            class="product-subtitle h4 text-capitalize"
                            >{{
                              contract.lineOfBusinessDisplay ||
                                contract.lineOfBusiness
                            }}</span
                          >
                        </ng-template>
                        <span
                          *ngIf="
                            contract.accountType &&
                              contract.accountType.toLowerCase() ===
                                'external account';
                            else otherLinks
                          "
                          class="summary-link"
                        >
                          <span
                            *ngIf="
                              contract.contractID &&
                              contract.contractID.indexOf('not available') <= 0
                            "
                          >
                            <span class="sr-only">Account Number: </span>
                            #{{ contract.contractID || contract.contractId }}
                          </span>
                        </span>
                        <ng-template #otherLinks>
                          <span
                            *ngIf="
                              !contract.accountType &&
                              contract.lineOfBusiness.toLowerCase() !=
                                'retirement'
                            "
                          >
                            <a
                              class="summary-link"
                              [href]="
                                contract.contractDetailLink
                                  | contractDetails
                                    : contract.lineOfBusiness
                                    : contract.contractID || contract.contractId
                              "
                            >
                              <span class="sr-only">Account Number: </span>
                              #{{
                                contract.contractID
                                  | mask
                                    : contract.maskContractID ||
                                        (contract.productTypeHeader &&
                                          contract.productTypeHeader.indexOf(
                                            'Masked'
                                          ) > -1) ||
                                        contract.contractId
                                  | mask
                                    : contract.maskContractId ||
                                        (contract.productTypeHeader &&
                                          contract.productTypeHeader.indexOf(
                                            'Masked'
                                          ) > -1)
                              }}
                            </a>
                          </span>
                        </ng-template>
                      </div>
                      <div class="mb-4">
                        <span
                          class="product-subtitle h4 summary-link"
                          *ngIf="
                            contract.accountType &&
                              contract.accountType.toLowerCase() ===
                                'external account';
                            else otherTitles
                          "
                        >
                          <span
                            *ngIf="contract.productTitle"
                            class="text-capitalize"
                            >{{ contract.productTitle }}</span
                          >
                        </span>
                        <ng-template #otherTitles>
                          <ng-container *ngIf="contract.enable2FA; else notHrt">
                            <a
                              class="product-subtitle h4 summary-link two-factor-modal"
                              href="javascript:void(0);"
                              two-factor-auth-modal
                              [contract]="contract"
                              [modalId]="'2fa_' + contract.contractID + '_' + i"
                            >
                              <span
                                class="transclude-content two-factor-modal text-capitalize product-type"
                                >{{ contract.productType }}</span
                              >
                              <span
                                class="transclude-content two-factor-modal"
                                >{{ contract.primaryContractValue.title }}</span
                              >
                            </a>
                          </ng-container>
                          <ng-template #notHrt>
                            <a
                              class="product-subtitle h4 summary-link"
                              *ngIf="!contract.accountType"
                              [href]="
                                contract.contractDetailLink
                                  | contractDetails
                                    : contract.lineOfBusiness
                                    : contract.contractID || contract.contractId
                              "
                            >
                              <span
                                *ngIf="
                                  contract.lineOfBusiness.toLowerCase() !==
                                  'annuity'
                                "
                                class="text-capitalize product-type"
                                >{{ contract.productType }}</span
                              >
                              <span
                                *ngIf="
                                  contract.lineOfBusiness.toLowerCase() ==
                                  'mutual funds'
                                "
                                >Mutual Funds</span
                              >
                              <span
                                *ngIf="
                                  contract.lineOfBusiness.toLowerCase() !==
                                  'mutual funds'
                                "
                                >{{ contract.primaryContractValue.title }}</span
                              >
                            </a>
                          </ng-template>
                          <!-- <a class="product-subtitle h4 summary-link" *ngIf="!contract.accountType" [href]="contract.contractDetailLink | contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)">
                                                            <span *ngIf="contract.lineOfBusiness.toLowerCase() !== 'annuity'" class="text-capitalize product-type">{{contract.productType}}</span>
                                                            <span *ngIf="contract.lineOfBusiness.toLowerCase() == 'mutual funds'">Mutual Funds</span>
                                                            <span *ngIf="contract.lineOfBusiness.toLowerCase() !== 'mutual funds'">{{contract.primaryContractValue.title}}</span>
                                                        </a> -->
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-xs-4 summary-value">
                      {{
                        contract.primaryContractValue.value
                          | currency: 'USD':'symbol-narrow':'1.2-2'
                      }}{{ obj.key == 'Income' ? '/yr' : '' }}
                    </div>
                  </div>
                  <div
                    *ngIf="
                      contract.secondaryContractValues &&
                      contract.secondaryContractValues.length > 0
                    "
                  >
                    <div
                      *ngFor="
                        let sec of contract.secondaryContractValues[0].group
                      "
                    >
                      <div
                        *ngIf="
                          sec.contributesTo &&
                          obj.key
                            .toLowerCase()
                            .indexOf(sec.contributesTo.toLowerCase()) > -1
                        "
                      >
                        <div class="col-xs-8 pl-0 btn-sm-block">
                          <div class="pt-2">
                            <span class="product-subtitle h4">{{
                              contract.lineOfBusinessDisplay ||
                                contract.lineOfBusiness
                            }}</span>
                            <span>
                              <a
                                class="summary-link"
                                [href]="
                                  contract.contractDetailLink
                                    | contractDetails
                                      : contract.lineOfBusiness
                                      : contract.contractID ||
                                          contract.contractId
                                "
                              >
                                <span class="sr-only">Account Number: </span>
                                #{{
                                  contract.contractID
                                    | mask
                                      : contract.maskContractID ||
                                          (contract.productTypeHeader &&
                                            contract.productTypeHeader.indexOf(
                                              'Masked'
                                            ) > -1) ||
                                          contract.contractId
                                    | mask
                                      : contract.maskContractId ||
                                          (contract.productTypeHeader &&
                                            contract.productTypeHeader.indexOf(
                                              'Masked'
                                            ) > -1)
                                }}
                              </a>
                            </span>
                          </div>
                          <div class="mb-4">
                            <a
                              class="product-subtitle h4 summary-link"
                              [href]="
                                contract.contractDetailLink
                                  | contractDetails
                                    : contract.lineOfBusiness
                                    : contract.contractID || contract.contractId
                              "
                            >
                              <span
                                *ngIf="
                                  contract.lineOfBusiness.toLowerCase() !==
                                  'annuity'
                                "
                                class="text-capitalize product-type"
                                >{{ contract.productType }}</span
                              >
                              <span
                                *ngIf="
                                  contract.lineOfBusiness.toLowerCase() ==
                                  'mutual funds'
                                "
                                >Mutual Funds</span
                              >
                              <span
                                *ngIf="
                                  contract.lineOfBusiness.toLowerCase() !==
                                  'mutual funds'
                                "
                                >{{ sec.title }}</span
                              >
                            </a>
                          </div>
                        </div>
                        <div class="col-xs-4 summary-value">
                          {{
                            sec.value | currency: 'USD':'symbol-narrow':'1.2-2'
                          }}{{ obj.key == 'Income' ? '/yr' : '' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="obj.value === '0'"
                class="panel-collapse collapse"
                [attr.id]="'summaryBucket_' + i"
              >
                <div
                  class="wcm-cnt panel-body mt-3 content-title"
                  *ngIf="topBucketData"
                >
                  <span [innerHtml]="topBucketData[i].shortDescription"></span>
                </div>
                <div
                  class="mt-3 mb-4"
                  href="javascript:void(0)"
                  *ngIf="obj.value === '0'"
                >
                  <div *ngIf="topBucketData">
                    <span *ngIf="topBucketData[i].articleLink">
                      <a
                        [href]="
                          _genericService.frameUrl(
                            topBucketData[i].articleLink
                          ) | safeUrl
                        "
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{
                          topBucketData[i].ctaText
                            ? topBucketData[i].ctaText
                            : 'Learn More'
                        }}
                        <span
                          class="fa fa-arrow-circle-right fa-fw"
                          aria-hidden="true"
                        ></span>
                        <span class="sr-only"
                          >About {{ obj.key }} opens in a new window</span
                        >
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 aggr-summary-bottom-1 pt-3 hidden-xs">
              <a href="javascript:void(0)" (click)="showFlag = false; this.activateSD('.activeSD')">
                <span class="fa fa-arrow-circle-left fa-fw" aria-hidden="true"></span>Back to Summary</a>
            </div>
          </div>
          <div class="row">
            <div class="wrap" *ngFor="let val of compData.aggVal; let i = index">
              <div class="col-md-4 well-cont summarybox" *ngIf="!showFlag">
                <div class="row">
                  <div class="col-xs-12" *ngIf="val.value">
                    <div class="wrapper">
                      <div class="tile-title" [attr.data-qa]="'top-bucket-tile-title-'+i">
                        <h3 class="h5 summary-title product-subtitle" [attr.data-qa]="'top-bucket-summary-title-'+i">
                          <ng-container *ngIf="val.value == '0'; else bucketNm">{{topBucketData[i].category}}</ng-container>
                          <ng-template #bucketNm>
                            <span *ngIf="val.key == 'Income'">
                            <span class="content-title" *ngIf="_aggregationService.noGuaranteeIncome">Annual Retirement Income</span>
                            <span class="content-title" *ngIf="!_aggregationService.noGuaranteeIncome">Guaranteed Annual Income</span>
                          </span>
                          <span class="content-title" *ngIf="val.key != 'Income'">{{ val.key }}</span>
                          </ng-template>
                        </h3>
                        <pru-tooltip *ngIf="val.value !== '0'"
                          [definitionID]="
                            val.key === 'Assets'
                              ? 'YourAssets'
                              : val.key === 'Income' &&
                                _aggregationService.noGuaranteeIncome
                              ? 'YourNGIncome'
                              : val.key === 'Income' &&
                                !_aggregationService.noGuaranteeIncome
                              ? 'YourIncome'
                              : 'YourBenefits'
                          "
                          [definitionLocation]="'UCD_Content/SA-LegalStatement'"
                          [clickTitle]="
                            val.key === 'Assets'
                              ? 'YourAssets'
                              : val.key === 'Income'
                              ? 'YourIncome'
                              : 'YourBenefits'
                          "
                          [screenReaderText]="
                            val.key === 'Assets'
                              ? 'Your Assets'
                              : val.key === 'Income'
                              ? 'Your Income'
                              : 'Your Benefits'
                          "
                          [analyticData]="
                            val.key === 'Assets'
                              ? 'Assets'
                              : val.key === 'Income'
                              ? 'Income'
                              : 'Benefits'
                          "
                        >
                        </pru-tooltip>
                        <div class="wcm-cnt content-body" [attr.data-qa]="'top-bucket-content-body-'+i" *ngIf="val.value !== '0'">
                          <p class="h1 summary-val">{{val.value | currency: 'USD':'symbol-narrow':'1.2-2'}}</p>
                        </div>
                        <div
                          class="wcm-cnt content-body" [attr.data-qa]="'top-bucket-content-body-'+i"
                          *ngIf="val.value === '0' && topBucketData"
                        >
                          <p [attr.data-qa]="'top-bucket-summary-shortDescription-'+i"
                            [innerHtml]="topBucketData[i].shortDescription"
                          ></p>
                        </div>
                        <p class="mb-0 mt-2">
                          <a [attr.data-qa]="'top-bucket-summary-show-details-'+i"
                            href="javascript:void(0)"
                            [class.activeSD] = "activeSD===i"
                            *ngIf="val.value !== '0'"
                            (click)="
                              activeSD = i;
                              showFlag = val.key;
                              this.activateSD('.activeDetail');
                              _genericService.expandView(
                                compData.contracts[
                                  compData.contracts.length - 1
                                ],
                                val.key
                              )
                            "
                          >
                            <span
                              class="fa fa-arrow-circle-right fa-fw"
                              aria-hidden="true"
                            ></span
                            >Show Details</a
                          >
                          <span
                            href="javascript:void(0)"
                            *ngIf="val.value === '0'"
                          >
                            <span *ngIf="topBucketData">
                              <span *ngIf="topBucketData[i].articleLink">
                                <a [attr.data-qa]="'top-bucket-summary-ctaText-'+i"
                                  [href]="
                                    _genericService.frameUrl(
                                      topBucketData[i].articleLink
                                    ) | safeUrl
                                  "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <span
                                    class="fa fa-arrow-circle-right fa-fw"
                                    aria-hidden="true"
                                  ></span
                                  >{{
                                    topBucketData[i].ctaText
                                      ? topBucketData[i].ctaText
                                      : 'Learn More'
                                  }}
                                  <span class="sr-only"
                                    >About {{ val.key }} opens in a new
                                    window</span
                                  >
                                </a>
                              </span>
                            </span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #errorCompData>
          <div class="" *ngIf="topBucketData" [attr.data-qa]="'top-bucket-fallback'">
            <div class="row">
              <div class="wrap" *ngFor="let entry of topBucketData; let i = index">
                <div class="col-md-4 well-cont summarybox" [attr.data-qa]="'top-bucket-summarybox-'+i">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="wrapper assets">
                        <div class="tile-title" [attr.data-qa]="'top-bucket-tile-title-'+i">
                          <h3 class="h5 summary-title product-subtitle" [attr.data-qa]="'top-bucket-summary-title-'+i">
                              {{topBucketData[i]?.category}}
                          </h3>
                          <div class="wcm-cnt content-body" [attr.data-qa]="'top-bucket-shortDescription-'+i">
                            <p>{{ topBucketData[i]?.shortDescription }}</p>
                          </div>
                          <span *ngIf="topBucketData[i].articleLink">
                            <a [attr.data-qa]="'top-bucket-articleLink-'+i"
                              [href]="
                                _genericService.frameUrl(
                                  topBucketData[i].articleLink
                                ) | safeUrl
                              "
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span
                                class="fa fa-arrow-circle-right fa-fw"
                                aria-hidden="true"
                              ></span
                              >{{
                                topBucketData[i].ctaText
                                  ? topBucketData[i].ctaText
                                  : 'Learn More'
                              }}<span class="sr-only"
                                >About {{ topBucketData[i].category }} opens in
                                a new window</span
                              ></a
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
